var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLiacat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1327_2315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3412 65.2995C66.3412 62.9255 64.4733 61 62.1706 61C59.8678 61 58 62.9255 58 65.2995C58 67.6734 59.8678 69.5989 62.1706 69.5989C64.4733 69.5989 66.3412 67.6734 66.3412 65.2995Z",
    fill: "#D9DBE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8294 61C81.5266 61 79.6588 62.9255 79.6588 65.2995C79.6588 67.6734 81.5266 69.5989 83.8294 69.5989C86.1322 69.5989 88 67.6734 88 65.2995C88 62.9255 86.1322 61 83.8294 61V61Z",
    fill: "#D9DBE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2097 80.1682C85.2627 79.6657 84.0981 80.0462 83.6071 81.0153C83.0879 82.049 82.0848 83.3842 80.2818 83.8795C78.2825 84.4251 75.5886 83.6785 74.7679 81.6829C74.7538 81.6542 74.7328 81.6255 74.7187 81.5968C74.6837 81.525 74.6486 81.446 74.6065 81.3742C77.7844 80.7712 80.1906 78.0434 80.1906 75.5165C80.1906 72.6595 77.118 70.75 73.3227 70.75C69.5275 70.75 66.4548 72.6595 66.4548 75.5165C66.4548 77.8926 68.5804 80.441 71.4777 81.2378C71.4496 81.2737 71.4216 81.3096 71.3935 81.3455C71.3444 81.4173 71.3093 81.5034 71.2672 81.5824C71.2532 81.6183 71.2322 81.6398 71.2181 81.6757C70.3974 83.6642 67.7035 84.4179 65.7042 83.8723C63.9012 83.377 62.8981 82.0418 62.3789 81.0081C61.8879 80.039 60.7303 79.6586 59.7763 80.161C58.8292 80.6635 58.4574 81.8552 58.9485 82.8243C60.1902 85.2865 62.2386 87.0165 64.708 87.6913C65.4516 87.8923 66.2443 88 67.0511 88C69.1837 88 71.3935 87.275 73 85.7818C74.6065 87.275 76.8163 88 78.9489 88C79.7557 88 80.5414 87.8995 81.292 87.6913C83.7614 87.0165 85.8099 85.2865 87.0516 82.8243C87.5426 81.8552 87.1708 80.6635 86.2238 80.161L86.2097 80.1682Z",
    fill: "#D9DBE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1327_2315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 27,
    fill: "white",
    transform: "translate(58 61)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiacat);
export default __webpack_public_path__ + "static/media/icon-liacat.bf0e8035cb599ed056894986749dd4c3.svg";
export { ForwardRef as ReactComponent };